import React from "react";
import { withTranslation } from 'react-i18next';
import { CorrespondenceType } from "./correspondence";

class CorrespondenceTypeParent extends React.Component {
    constructor(props) {
    super(props);
    this.state = {

    }
  }
  render() {
    return <CorrespondenceType  {...this?.props}/>;
  }
}

export default withTranslation('correspondence') (CorrespondenceTypeParent);
